import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push

Vue.use(Router)
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/pages/login')
    },
    {
        path: '/accountLogin',
        component: () => import('@/pages/accountLogin')
    },
    {
        path: '/shopShare',
        component: () => import('@/pages/shopShare')
    },
    {
        path: '/personShare',
        component: () => import('@/pages/personShare')
    },
    {
        path: '/poster',
        component: () => import('@/pages/poster')
    },
    {
        path: '/dingTalkLink',
        component: () => import('@/pages/dingTalkLink')
    },
    {
        path: '/screen',
        component: () => import('@/pages/screen')
    },
    {
        path: '/nopermission',
        component: () => import('@/layout1'),
        children: [
            {
                path: 'index',
                component: () => import('@/pages/nopermission')
            }
        ]
    },
    {
        path: '/index',
        component: () => import('@/layout1'),
        children: [
            {
                path: 'index',
                component: () => import('@/pages/home2')
            }
        ]
    }
];
export const asyncRoutes = [
    {
        path: '/home',
        component: () => import('@/layout1'),
        meta: {
            title: '首 页',
            menuComponent: 'home',
            icon: 'icon-gaikuang',
            role: 'admin_index',
            role_types: [1, 2, 3]
        },
        children: [
            {
                path: 'index',
                name: 'home',
                component: () => import('@/pages/home1'),
                meta: {
                    menuPath: ['首页']
                }
            }
        ]
    },
    {
        path: '/anchor',
        component: () => import('@/layout1'),
        meta: {
            title: '直 播 人 员',
            menuComponent: 'anchor',
            icon: 'icon-zhubo',
            role: 'admin_anchor',
            role_types: [1, 2, 3]
        },
        children: [
            {
                path: 'index',
                name: 'anchor',
                component: () => import('@/pages/business/coAnchor'),
                meta: {
                    menuPath: ['主播库']
                }
            },
            {
                path: 'detail',
                name: 'anchorDetail',
                component: () => import('@/pages/anchor/detail'),
                meta: {
                    title: '详情',
                    menuPath: ['主播库', '详情']
                }
            },
            {
                path: 'info',
                name: 'info',
                component: () => import('@/pages/anchor/info1'),
                meta: {
                    title: '详情',
                    menuPath: ['主播库', '详情']
                }
            },
            {
                path: 'infoBusiness',
                name: 'infoBusiness',
                component: () => import('@/pages/anchor/infoBusiness1'),
                meta: {
                    title: '详情',
                    menuPath: ['主播库', '详情'],
                    role_types: []
                }
            },
            {
                path: 'person',
                name: 'person',
                component: () => import('@/pages/anchor/person'),
                meta: {
                    title: '个人主页',
                    menuPath: ['主播库', '个人主页']
                }
            },
            {
                path: 'monthSaleDetails',
                name: 'personMonthSaleDetails',
                component: () => import('@/pages/anchor/monthSaleDetails'),
                meta: {
                    title: '月度销售明细',
                    menuPath: ['主播库', '个人主页', '月度销售明细']
                }
            },
            {
                path: 'share',
                name: 'share',
                component: () => import('@/pages/anchor/share'),
                meta: {
                    title: '分享',
                    menuPath: ['主播库', '分享']
                }
            }
        ]
    },
    {
        path: '/data',
        component: () => import('@/layout1'),
        meta: {
            title: '数 据',
            menuComponent: 'dataModel',
            icon: 'icon-shuju',
            role: 'admin_data',
            role_types: [1, 2, 3]
        },
        children: [
            {
                path: 'anchor',
                name: 'dataAnchor',
                component: () => import('@/pages/data/anchor'),
                meta: {
                    title: '人员数据汇总',
                    menuPath: ['人员数据汇总']
                }
            },
            {
                path: 'shop',
                name: 'dataShop',
                component: () => import('@/pages/data/shop'),
                meta: {
                    title: '店铺数据汇总',
                    menuPath: ['店铺数据汇总']
                }
            }
        ]
    },
    {
        path: '/shop',
        component: () => import('@/layout1'),
        meta: {
            title: '直 播 监 控',
            menuComponent: 'shop',
            icon: 'icon-dianpu',
            role: 'admin_shop',
            role_types: [1, 2, 3]
        },
        children: [
            {
                path: 'index',
                name: 'shop',
                component: () => import('@/pages/shop'),
                meta: {
                    menuPath: ['店铺列表']
                }
            },
            {
                path: 'details',
                name: 'details',
                component: () => import('@/pages/shop/details'),
                meta: {
                    title: '店铺主页',
                    menuPath: ['店铺列表', '店铺主页']
                }
            },
            {
                path: 'monthSaleDetails',
                name: 'monthSaleDetails',
                component: () => import('@/pages/shop/monthSaleDetails'),
                meta: {
                    title: '月度销售明细',
                    menuPath: ['店铺列表', '店铺主页', '月度销售', '明细']
                }
            },
            {
                path: 'shopSetting',
                name: 'shopSetting',
                component: () => import('@/pages/business/platformSetting'),
                meta: {
                    title: '店铺设置',
                    menuPath: ['店铺列表', '店铺设置']
                }
            },
            {
                path: 'shopScreen',
                name: 'shopScreen',
                component: () => import('@/pages/shopScreen'),
                meta: {
                  menuPath: ['店铺列表']
                }
            },
            {
                path: 'shopScreen1',
                name: 'shopScreen1',
                component: () => import('@/pages/shopScreen1'),
                meta: {
                  menuPath: ['店铺列表']
                }
            }
        ]
    },
    {
        path: '/business',
        component: () => import('@/layout1'),
        meta: {
            title: '商 家',
            menuComponent: 'business',
            icon: 'icon-shangjia',
            role: '',
            role_types: [2, 3]
        },
        children: [
            {
                path: 'shopManage',
                name: 'shopManage',
                component: () => import('@/pages/business/shopManage'),
                meta: {
                    title: '店铺管理',
                    menuPath: ['商家后台'],
                    role_types: [2, 3]
                }
            },
            // {
            //     path: 'coAnchor',
            //     name: 'coAnchor',
            //     component: () => import('@/pages/business/coAnchor'),
            //     meta: {
            //         title: '合作主播',
            //         menuPath: ['商家后台'],
            //         role_types: [2]
            //     }
            // },
            {
                path: 'materialManage',
                name: 'materialManage',
                component: () => import('@/pages/business/materialManage'),
                meta: {
                    title: '资料管理',
                    menuPath: ['商家后台'],
                    role_types: [2]
                }
            },
            {
                path: 'makeupManage',
                name: 'makeupManage',
                component: () => import('@/pages/business/makeupManage'),
                meta: {
                    title: '妆发师管理',
                    menuPath: ['商家后台'],
                    role_types: [2]
                }
            },
            {
                path: 'platformSetting',
                name: 'platformSetting',
                component: () => import('@/pages/business/platformSetting'),
                meta: {
                    title: '平台设置',
                    menuPath: ['商家后台'],
                    role_types: [2, 3]
                }
            },
            {
                path: 'anchorEvaluateRule',
                name: 'anchorEvaluateRule',
                component: () => import('@/pages/business/anchorEvaluateRule'),
                meta: {
                    menuPath: ['主播评定规则']
                },
                hidden: true
            }

        ]
    },
    {
        path: '/schedule',
        component: () => import('@/layout1'),
        meta: {
            title: '排 班',
            menuComponent: 'schedule',
            icon: 'icon-zhiboshichang1',
            role: '',
            role_types: [1, 2, 3]
        },
        children: [
            {
                path: 'shop',
                name: 'shopSchedule',
                component: () => import('@/pages/schedule/shop'),
                meta: {
                    title: '店铺排班',
                    menuPath: ['排班', '店铺排班']
                }
            },
            {
                path: 'anchor',
                name: 'anchorSchedule',
                component: () => import('@/pages/schedule/anchor'),
                meta: {
                    title: '直播人员排班',
                    menuPath: ['排班', '直播人员排班']
                }
            },
            {
                path: 'makeup',
                name: 'makeupSchedule',
                component: () => import('@/pages/schedule/makeup'),
                meta: {
                    title: '妆发师排班',
                    menuPath: ['排班', '妆发师排班']
                }
            },
            {
                path: 'face',
                name: 'face',
                component: () => import('@/pages/schedule/face'),
                meta: {
                    title: '人脸识别',
                    menuPath: ['排班', '人脸识别']
                }
            },
            {
                path: 'shopDetail',
                name: 'shopDetailSchedule',
                component: () => import('@/pages/schedule/shopDetail'),
                meta: {
                    menuPath: ['排班', '店铺排班详情']
                },
                hidden: true
            },
            {
                path: 'anchorDetail',
                name: 'anchorDetailSchedule',
                component: () => import('@/pages/schedule/anchorDetail'),
                meta: {
                    menuPath: ['排班', '主播排班详情']
                },
                hidden: true
            },
            {
                path: 'makeupDetail',
                name: 'makeupDetailSchedule',
                component: () => import('@/pages/schedule/makeupDetail'),
                meta: {
                    menuPath: ['排班', '妆发师排班详情']
                },
                hidden: true
            },
        ]
    },
    {
        path: '/examine',
        component: () => import('@/layout1'),
        meta: {
            title: '审 核',
            menuComponent: 'examine',
            icon: ''
        },
        children: [
            {
                path: 'makeup',
                name: 'makeupExamine',
                component: () => import('@/pages/examine/makeup'),
                meta: {
                    title: '妆发审核',
                    menuPath: ['审核', '妆发审核']
                }
            },
            {
                path: 'schedule',
                name: 'scheduleExamine',
                component: () => import('@/pages/examine/schedule'),
                meta: {
                    title: '排班审核',
                    menuPath: ['审核', '排班审核']
                }
            },
            {
                path: 'appendTime',
                name: 'appendExamine',
                component: () => import('@/pages/examine/append'),
                meta: {
                    title: '补签审核',
                    menuPath: ['审核', '补签审核'],
                    badge: 'signCount'
                }
            }
        ]
    },
    {
        path: '/launchBoard',
        component: () => import('@/layout1'),
        meta: {
            title: '投 放 看 板',
            menuComponent: 'board',
            icon: ''
        },
        children: [
            {
                path: 'getMonitorList',
                name: 'getMonitorList',
                component: () => import('@/pages/launchBoard/getMonitorList'),
                meta: {
                    title: '实时监控',
                    menuPath: ['投放看板', '实时监控']
                }
            },
            {
                path: 'globalPromotion',
                name: 'globalPromotion',
                component: () => import('@/pages/launchBoard/globalPromotion'),
                meta: {
                    title: '全域推广',
                    menuPath: ['投放看板', '全域推广'],
                    badge: 'warnCount'
                }
            },
            {
                path: 'viewMorePage',
                name: 'viewMorePage',
                component: () => import('@/pages/launchBoard/viewMorePage'),
                meta: {
                    title: '查看更多',
                    menuPath: ['投放看板', '查看更多']
                },
                hidden: true
            },
            {
                path: 'historicalScreenshotPage',
                name: 'historicalScreenshotPage',
                component: () => import('@/pages/launchBoard/historicalScreenshotPage'),
                meta: {
                    title: '历史截屏',
                    menuPath: ['投放看板', '历史截屏']
                },
                hidden: true
            },
            {
                path: 'getGlobalPromotionDetail',
                name: 'getGlobalPromotionDetail',
                component: () => import('@/pages/launchBoard/getGlobalPromotionDetail'),
                meta: {
                    title: '全域推广详情',
                    menuPath: ['投放看板', '全域推广详情']
                },
                hidden: true
            }
        ]
    },


    {
        path: '/anchorHome',
        name: 'anchorHome',
        component: () => import('@/layout'),
        meta: {
            title: '',
            role: 'anchor_index',
            role_types: []
        },
        children: [
            {
                path: 'index',
                component: () => import('@/pages/anchorHome'),
                meta: {
                    menuPath: [],
                    role_types: []
                }
            },
            {
                path: 'anchorShop',
                name: 'anchorShop',
                component: () => import('@/pages/anchorShop'),
                meta: {
                    title: '店铺',
                    menuPath: ['店铺'],
                    role_types: []
                },
            },
            {
                path: 'anchorPerson',
                name: 'anchorPerson',
                component: () => import('@/pages/anchorPerson'),
                meta: {
                    title: '个人主页',
                    menuPath: ['店铺', '个人主页'],
                    role_types: []
                },
            },
            {
                path: 'shopUnbound',
                name: 'shopUnbound',
                component: () => import('@/pages/shopUnbound'),
                meta: {
                    title: '已解绑店铺',
                    menuPath: ['已解绑店铺'],
                    role_types: []
                },
            },
            {
                path: 'anchorMonthSaleDetails',
                name: 'anchorMonthSaleDetails',
                component: () => import('@/pages/anchorHome/anchorMonthSaleDetails'),
                meta: {
                    title: '月度销售',
                    menuPath: ['店铺', '个人主页', '月度销售', '明细'],
                    role_types: []
                }
            }
        ]
    },
    {
        path: '/anchorData',
        component: () => import('@/layout'),
        meta: {
            title: '',
            role: 'anchor_data',
            role_types: []
        },
        children: [
            {
                path: 'index',
                name: 'anchorData',
                component: () => import('@/pages/anchorData'),
                meta: {
                    menuPath: ['数据汇总'],
                    role_types: []
                }
            }
        ]
    }
]


const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js